import { NameGenerator } from "assets/icons";
import { BlankAction } from "components/actions";
import {
  InformationSetting,
  MultiLineSetting,
  RememberSettings,
  ToggleSetting,
} from "components/settings";
import { WidgetNames } from "constants/widgets";
import { WidgetType } from "types/Widget";
import { LINE_LIMIT_RANDOM_NAME } from "util/widgeTransformData";

import { InteractiveRandomName, InteractiveRandomNameState } from "./RandomName";
import { RandomNameWordList } from "./RandomNameWordList";

export const InteractiveRandomNameWidget: WidgetType<InteractiveRandomNameState> = {
  name: "Flashcards",
  component: InteractiveRandomName,
  icon: NameGenerator,
  showOnToolbar: true,
  sizing: {
    minWidth: 200,
    minHeight: 145,
    minAspectRatio: 1,
    maxAspectRatio: 2,
  },
  defaultState: {
    displayName: "...",
    remainingNames: [],
    usedNames: [],
  },
  defaultSize: {
    aspectRatio: 2,
    widthPercentage: 20,
  },
  settings: {
    info: {
      editor: InformationSetting,
      info: {
        info: "Displays a random name from the list of options.<br /><br />Add names to the list below and then click the shuffle button to display a new option.",
      },
    },
    nameList: {
      editor: MultiLineSetting,
      info: {
        lineLimit: LINE_LIMIT_RANDOM_NAME,
        settingName: "Names",
      },
      defaultValue: "Jane\nJoe",
    },
    saveWords: {
      editor: RandomNameWordList,
      info: {
        settingName: "nameList",
      },
    },
    isSequential: {
      editor: ToggleSetting,
      info: {
        label: "Sequential",
      },
      defaultValue: false,
    },
    rememberSettings: {
      editor: RememberSettings,
      info: {
        widgetName: WidgetNames.randomName,
        widgetDisplayName: "Flashcards",
      },
    },
  },
  quickActions: {
    blank: BlankAction,
  },
};
